import type { IProjectOwner } from '@/pshared/model/projectOwner.model'
import type { ISite } from '@/pshared/model/site.model'
import type { IThing } from '@/pshared/model/thing.model'
import type { CustomDetail } from '@/types/backendevent'
import type { IGsm2 } from '@/types/gsm2'
import type { IGsm2Weight } from '@/types/gsm2weight'
import type { IDevice } from '@/types/idevice'
import type { JoinAgentUser } from '@/types/joinagentuser'
import type { ILog } from '@/types/log'
import type { ISiteX } from '@/types/sitex'
import type { IThingX } from '@/types/thingx'
import type { IUser } from '@/types/user'
import { reactive } from 'vue'

//import { isMobile, deviceType, isTablet } from "mobile-device-detect";


export const navlocale = reactive({ navlang: '', tz: '' })

//shochartlog

export const sho = reactive({
  chartlog: false,
})


export const cnav = reactive({
  cpath: '/h',
  from: '',
  to: '',
  identified: false,
  logout: false
})

export const host = reactive({
  base: '',
  base_gtw: '',
  api: '',
  api_gtw: '',
  ws: ''
})

export const cuser = reactive({
  login: '',
  password: '',
  identified: false,
})



/*
export interface IGsm2Weight {
  id: number;
  interval: number;
  annotation?: string | undefined;
  scale_measure: number;
  scale_measure_raw: number;
  scale_temperature: number;
}




let _measrs: IGsm2Weight[] = [{
  id: 0,
  interval: 0,
  scale_measure: 0,
  scale_measure_raw: 0,
  scale_temperature: 0,
}]

*/

let _measr: IGsm2Weight = {
  id: 0,
  interval: 0,
  scale_measure: 0,
  scale_measure_raw: 0,
  scale_temperature: 0,
}

let _logger: string[] = []
let _clogs: ILog[] = []


let _gsm2: IGsm2 = {
  sim_id: "",
  ss_id: "",
  version: "",
  signal_quality: 0,
  comment: "",
  wakeup_id: 0,
  vcc: 0,
  interval: 0,
  sequence: 0,
  am_temperature: 0,
  am_humidity: 0,
  bme_temper: 0,
  bme_humidity: 0,
  bme_pressr: 0,
  bme_altitude: 0,
  lux: 0,
  mlx_object: 0,
  mlx_ambient: 0,
  filler: 0,
  weights: [_measr],
}


export const simul = reactive(
  {
    logger: _logger,
    gsm2: _gsm2,
    measr: _measr,
    clogs: _clogs
  }
)

let defaultProjectOwner_: IProjectOwner = { id: 0 }
let projectOwners_: IProjectOwner[] = []
let joinagents_: JoinAgentUser[] = []
let accessibleThings_: IThingX[] = []
let contextThings_: IThingX[] = []
let things_: IThingX[] = []
let currentSites_: ISiteX[] = []
let sites_: ISiteX[] = []
let devices_: IDevice[] = []

//let thingjentity_: IThingX //| undefined = undefined

//let thingpentity_: IThingX //| undefined = undefined


let thingjentity_: IThingX = {
  id: -1,
  selected: false
}

let thingpentity_: IThingX = {
  id: -1,
  selected: false
}







export const current = reactive(
  {
    thingjentity: thingjentity_,
    thingpentity: thingpentity_
  }
)


export const cache = reactive(
  {
    defaultProjectOwner: defaultProjectOwner_,
    projectOwners: projectOwners_,
    joinagents: joinagents_,
    currentSites: currentSites_,
    sites: sites_,
    accessibleThings: accessibleThings_,
    contextThings: contextThings_,
    things: things_,
    devices: devices_,
  }
)




export const navmode = reactive({
  mini: false,
  offcanv: true
})


export const devmode = reactive({
  dev: false,
})


export const currentYears: number[] = reactive([])

export const currentMonths: number[] = reactive([0])

export const wdim = reactive({
  height: 0,
  width: 0,
  x: 0,
  y: 0,
  viewport: 'md',
  device: 'mobile'
})

export const cusers: IUser[] = reactive([])

export const cResponse: CustomDetail = reactive({
  type: '',
  data: '',
  value: ''
})

export const autoprogress = reactive({ mode: true })


/*
CustomDetail {
  type: string,
  data: string,
  clazz?: string | null,
  key?: string | null,
  recipient?: string | null,
  id?: string | null,
  sender?: string | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value:any,
}

*/


export const bResponse: CustomDetail = reactive({
  type: '',
  data: '',
  value: undefined
})

export const bMessage: CustomDetail = reactive({
  type: '',
  data: '',
  value: ''
})
